import React, { useEffect, useState } from "react";
import pruefPlanStores from "../../Stores/PruefPlanStore";
import Inspection_constants from "../../Constants/InspectionConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import InspectionAction from "../../Actions/InspectionAction";
import InspectionStore from "../../Stores/InspectionStores";
import EditInspectionRecords from "./EditInspectionRecords";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import { useLanguageContext } from "../../Context/LanguageContext";
import { toast } from "react-toastify";
import commonUtils from "../../helpers/commonUtils";
import { customizeFilter } from "../FilterOptions/CustomizeFilter";

export default function NotPassedInspection() {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [notSavedInspectionList, setNotSavedInspectionList] = useState([]);
  const [tempList, setTempList] = useState([]);
  const [selectedInspection, setSelectedInspection] = useState(null);

  const filteruserList = (e) => {
    if (e.target.value != "") {
      let tempUserList = [...tempList];
      let tempUserList1 = [];

      /**return the filter result start*/

      tempUserList1 = customizeFilter(tempUserList, e.target.value, "id");

      /**return the filter result end */

      setNotSavedInspectionList(tempUserList1);
    } else {
      setNotSavedInspectionList(tempList);
    }
  };

  useEffect(() => {
    setGlobalSpinner(true);
    InspectionAction.getNotPassedInspetion();
  }, []);

  useEffect(() => {
    function getNotPassedInspectionSuccess() {
      const res = InspectionStore.getResult();

      if (res) {
        setTempList(res);
        setNotSavedInspectionList(res);
      } else {
      }
      setGlobalSpinner(false);
    }

    function getNotPassedInspectionFailure() {
      const res = InspectionStore.getResult();

      setGlobalSpinner(false);
    }

    InspectionStore.addChangeListener(
      Inspection_constants.GET_NOTPASSED_INSPECTION_SUCCESS,
      getNotPassedInspectionSuccess
    );
    InspectionStore.addChangeListener(
      Inspection_constants.GET_NOTPASSED_INSPECTION_FAILURE,
      getNotPassedInspectionFailure
    );
    return () => {
      InspectionStore.removeChangeListener(
        Inspection_constants.GET_NOTPASSED_INSPECTION_SUCCESS,
        getNotPassedInspectionSuccess
      );
      InspectionStore.removeChangeListener(
        Inspection_constants.GET_NOTPASSED_INSPECTION_FAILURE,
        getNotPassedInspectionFailure
      );
    };
  }, []);

  useEffect(() => {
    function UpdateInspectionRecordSuccess() {
      const res = InspectionStore.getResult();
      if (res) {
        toast.success(localization.succes);

        commonUtils.hideModalPopUp("editInspectionRecordModalClose");

        InspectionAction.getNotPassedInspetion();
      }
    }

    function UpdateInspectionRecordFailure() {
      const res = InspectionStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    InspectionStore.addChangeListener(
      Inspection_constants.UPDATE_RECORD_SUCCESS,
      UpdateInspectionRecordSuccess
    );

    InspectionStore.addChangeListener(
      Inspection_constants.UPDATE_RECORD_FAILURE,
      UpdateInspectionRecordFailure
    );

    return () => {
      InspectionStore.removeChangeListener(
        Inspection_constants.UPDATE_RECORD_SUCCESS,
        UpdateInspectionRecordSuccess
      );

      InspectionStore.removeChangeListener(
        Inspection_constants.UPDATE_RECORD_FAILURE,
        UpdateInspectionRecordFailure
      );
    };
  }, []);

  function RenderEditButton(props) {
    return (
      <>
        <AiOutlineEdit
          className="mr-4 cursorPoint svgIcon"
          id="editInspectionRecord"
          title={localization.edit}
          size={20}
          onClick={() => {
            setSelectedInspection(props.id);
          }}
          data-toggle="modal"
          data-target="#editInspectionRecordModal"
        />
      </>
    );
  }

  return (
    <>
      <div className="w-100 h-100">
        <div className="container-fluid">
          <div className=" row p-4 px-3 d-flex justify-content-between form-outline">
            <input
              type="search"
              id="form1"
              className="form-control"
              placeholder={localization.searchPlaceholder}
              aria-label="Search"
              onChange={(e) => {
                filteruserList(e);
              }}
            />
          </div>
          <div
            className="table-responsive px-3 tableHeightMax"
            // style={{ maxHeight: "70vh" }}
          >
            <table className="table align-middle mb-0 table-striped table-hover table-sticky">
              <thead className="bg-light">
                <tr>
                  <th>{localization.organisation}</th>
                  <th>{localization.clientId}</th>
                  <th>{localization.equipmentGroupName}</th>
                  <th>{localization.inventanrnr}</th>
                  <th>{localization.updatedOn} </th>
                  <th>{localization.action}</th>
                </tr>
              </thead>
              <tbody>
                {notSavedInspectionList.length === 0 ? (
                  <tr>
                    <td className="text-center" colSpan={100}>
                      <p>{localization.noRecordFound}</p>
                    </td>
                  </tr>
                ) : (
                  notSavedInspectionList.map((row, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <p className="fw-normal mb-1">{row.organisation}</p>
                        </td>
                        <td>
                          <p className="fw-normal mb-1">{row.clientID}</p>
                        </td>
                        <td>
                          <p className="fw-normal mb-1">{row.equipmentGroup}</p>
                        </td>
                        <td>
                          <p className="fw-normal mb-1">{row.inventryNumber}</p>
                        </td>
                        <td>
                          <p className="fw-normal mb-1">
                            {row.updatedOn.split("T")[0]}
                          </p>
                        </td>
                        <td>
                          <div className="d-flex">
                            <>
                              <RenderEditButton id={row.id} />
                            </>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <EditInspectionRecords
        selectedInspection={selectedInspection}
        setSelectedInspection={setSelectedInspection}
      />
    </>
  );
}
